// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root, :root.default {
    /* Base colors */
    --text-color: #595959;
    --text-color-link: #337ab7;
    --text-color-disabled: #999;
    --container-bg-color: #f8f8f8;
    --input-bg-color: white;
    --input-bg-color-disabled: #eee;
    --border-color: #bbb;
    --color-active: #078aa3;
    --focus-outline: 2px solid #3584e4;
    /* Tooltips */
    --tooltip-bg-color: rgba(0, 0, 0, 0.75);
    --tooltip-text-color: white;
    --tooltip-border-color: black;
    /* Map buttons */
    --map-button-bg-color: #595959;
    --map-button-text-color: white;
    --map-button-hover-bg-color: #f2f2f2;
    --map-button-hover-text-color: #595959;
    --map-button-active-bg-color: #f2f2f2;
    --map-button-active-text-color: #595959;
    /* Panels (topbar and bottom bar) */
    --panel-bg-color: rgba(255, 255, 255, 0.75);
    --panel-text-color: #595959;
    /* Titlebars */
    --titlebar-bg-color: #595959;
    --titlebar-text-color: white;
    /* Button */
    --button-bg-color: #e9e9e9;
    --button-bg-color-hover: #dcdcdc;
    --button-bg-color-active: #078aa3;
    --button-bg-color-active-hover: #06798d;
    --button-bg-color-disabled: #e9e9e9;
    --button-text-color: #595959;
    --button-text-color-hover: #595959;
    --button-text-color-active: white;
    --button-text-color-active-hover: white;
    --button-text-color-disabled: #bbb;
    /* List */
    --list-bg-color: white;
    --list-section-bg-color: #ccc;
    --list-section-text-color: #595959;
    --list-item-bg-color-even: #f0f0f0;
    --list-item-bg-color-hover: #dcdcdc;
    --list-item-bg-color-active: #078aa3;
    --list-item-bg-color-active-hover: #06798d;
    --list-item-text-color-hover: #595959;
    --list-item-text-color-active: white;
    --list-item-text-color-active-hover: white;
    /* App menu */
    --app-menu-bg-color: #f2f2f2;
    --app-menu-text-color: #595959;
    --app-menu-bg-color-hover: white;
    --app-menu-text-color-hover: #595959;
    --app-submenu-bg-color: #808080;
    --app-submenu-text-color: white;
    --app-submenu-bg-color-hover: #a0a0a0;
    --app-submenu-text-color-hover: white;
}
`, "",{"version":3,"sources":["webpack://./components/style/DefaultColorScheme.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,oBAAoB;IACpB,uBAAuB;IACvB,kCAAkC;IAClC,aAAa;IACb,uCAAuC;IACvC,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;IAChB,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;IACpC,sCAAsC;IACtC,qCAAqC;IACrC,uCAAuC;IACvC,mCAAmC;IACnC,2CAA2C;IAC3C,2BAA2B;IAC3B,cAAc;IACd,4BAA4B;IAC5B,4BAA4B;IAC5B,WAAW;IACX,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mCAAmC;IACnC,4BAA4B;IAC5B,kCAAkC;IAClC,iCAAiC;IACjC,uCAAuC;IACvC,kCAAkC;IAClC,SAAS;IACT,sBAAsB;IACtB,6BAA6B;IAC7B,kCAAkC;IAClC,kCAAkC;IAClC,mCAAmC;IACnC,oCAAoC;IACpC,0CAA0C;IAC1C,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;IAC1C,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,gCAAgC;IAChC,oCAAoC;IACpC,+BAA+B;IAC/B,+BAA+B;IAC/B,qCAAqC;IACrC,qCAAqC;AACzC","sourcesContent":[":root, :root.default {\n    /* Base colors */\n    --text-color: #595959;\n    --text-color-link: #337ab7;\n    --text-color-disabled: #999;\n    --container-bg-color: #f8f8f8;\n    --input-bg-color: white;\n    --input-bg-color-disabled: #eee;\n    --border-color: #bbb;\n    --color-active: #078aa3;\n    --focus-outline: 2px solid #3584e4;\n    /* Tooltips */\n    --tooltip-bg-color: rgba(0, 0, 0, 0.75);\n    --tooltip-text-color: white;\n    --tooltip-border-color: black;\n    /* Map buttons */\n    --map-button-bg-color: #595959;\n    --map-button-text-color: white;\n    --map-button-hover-bg-color: #f2f2f2;\n    --map-button-hover-text-color: #595959;\n    --map-button-active-bg-color: #f2f2f2;\n    --map-button-active-text-color: #595959;\n    /* Panels (topbar and bottom bar) */\n    --panel-bg-color: rgba(255, 255, 255, 0.75);\n    --panel-text-color: #595959;\n    /* Titlebars */\n    --titlebar-bg-color: #595959;\n    --titlebar-text-color: white;\n    /* Button */\n    --button-bg-color: #e9e9e9;\n    --button-bg-color-hover: #dcdcdc;\n    --button-bg-color-active: #078aa3;\n    --button-bg-color-active-hover: #06798d;\n    --button-bg-color-disabled: #e9e9e9;\n    --button-text-color: #595959;\n    --button-text-color-hover: #595959;\n    --button-text-color-active: white;\n    --button-text-color-active-hover: white;\n    --button-text-color-disabled: #bbb;\n    /* List */\n    --list-bg-color: white;\n    --list-section-bg-color: #ccc;\n    --list-section-text-color: #595959;\n    --list-item-bg-color-even: #f0f0f0;\n    --list-item-bg-color-hover: #dcdcdc;\n    --list-item-bg-color-active: #078aa3;\n    --list-item-bg-color-active-hover: #06798d;\n    --list-item-text-color-hover: #595959;\n    --list-item-text-color-active: white;\n    --list-item-text-color-active-hover: white;\n    /* App menu */\n    --app-menu-bg-color: #f2f2f2;\n    --app-menu-text-color: #595959;\n    --app-menu-bg-color-hover: white;\n    --app-menu-text-color-hover: #595959;\n    --app-submenu-bg-color: #808080;\n    --app-submenu-text-color: white;\n    --app-submenu-bg-color-hover: #a0a0a0;\n    --app-submenu-text-color-hover: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
